import React from 'react';
import classNames from 'classnames';
import { ErrorMessage } from '../ErrorMessage/ErrorMessage';
/**
 * Bronson Checkbox component.
 *
 * @see https://bronson.vwfs.io/default/components/detail/bronson-checkbox.html
 *
 * @constructor
 */
export function Checkbox({ children, className, errorMessage, id, required, requiredText, testId, ...otherProps }) {
    const labelClassNameList = classNames('c-checkbox', className).trim();
    const inputClassNameList = classNames('c-checkbox__input').trim();
    /**
     * If {@link required} is set, render a `required` flag according {@link requiredText}.
     */
    const renderIfRequired = (required, requiredText) => {
        return required ? React.createElement("span", { "aria-hidden": "true" }, requiredText) : null;
    };
    const renderIfError = () => {
        if (!errorMessage)
            return null;
        return typeof errorMessage === 'string' ? React.createElement(ErrorMessage, { id: id }, errorMessage) : errorMessage;
    };
    return (React.createElement("label", { className: labelClassNameList, htmlFor: id },
        React.createElement("input", { id: id, className: inputClassNameList, type: "checkbox", "aria-invalid": !!errorMessage || undefined, "aria-describedby": errorMessage ? `error-${id}` : undefined, required: required ? true : undefined, "data-testid": testId, ...otherProps }),
        React.createElement("span", { className: "c-checkbox__label" },
            children,
            renderIfError(),
            renderIfRequired(required, requiredText))));
}
